/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} End_Tolerance_HelpInputs */



/**
* | output |
* | --- |
* | "Tolerance for end points in seconds" |
*
* @param {End_Tolerance_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const end_tolerance_help = /** @type {((inputs?: End_Tolerance_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<End_Tolerance_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tolérance pour les points de fin en secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Toleranz für Endpunkte in Sekunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tolleranza per i punti finali in secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Допустимое отклонение для конечных точек в секундах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tolerancia para puntos finales en segundos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("终点容差（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エンドポイントの許容範囲（秒単位）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम बिंदुओं के लिए सहनशीलता (सेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tolerância para pontos finais em segundos")
	return /** @type {LocalizedString} */ ("Tolerance for end points in seconds")
});